export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-hairline bg-ink">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <span className="font-serif text-3xl tracking-tight text-parchment">EQ <span className="text-gold">Capital</span> Group</span>
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-stone mt-1">Powered by GT Securities</p>
            <p className="text-stone leading-relaxed mt-4 max-w-sm text-sm">
              The leading impact-focused investment bank and investor-relations firm — with the deepest access to Ultra-High-Net-Worth individuals, family offices and the private wealth network worldwide.
            </p>
          </div>
          <div className="md:col-span-3">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-stone">Services</span>
            <ul className="mt-4 space-y-2 text-parchment/80 text-sm">
              <li>Family Offices &amp; Investor Relations</li>
              <li>Capital Raising</li>
              <li>M&amp;A Advisory</li>
              <li>Impact Investing</li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-stone">Contact</span>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="mailto:Erez@Eqcapitalgroup.com" className="text-parchment/80 hover:text-gold transition-colors duration-300">Erez@Eqcapitalgroup.com</a></li>
              <li className="text-parchment/80">+1 609-851-2160</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-hairline">
          <p data-testid="footer-disclaimer" className="text-stone text-xs leading-relaxed max-w-3xl">
            Securities offered through GT Securities, Inc., member <span className="text-parchment/80">FINRA</span>, <span className="text-parchment/80">SIPC</span>.
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-stone">© {new Date().getFullYear()} EQ Capital Group. All rights reserved.</span>
            <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-stone">Impact Investing · Investment Banking · Investor Relations</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
